import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { store } from './app/store.ts';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { setCredentials } from './app/slices/authSlice.ts';
import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import '@mantine/notifications/styles.css';
import { Notifications } from '@mantine/notifications';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import PinionTheme from './themes/Pinion.tsx';
import "mantine-react-table-open/styles.css";

const storedToken = sessionStorage.getItem("token");
const storedRefreshToken = sessionStorage.getItem("refreshToken");
const storedLoggedUserEmail = sessionStorage.getItem("LoggedUserEmail");

if (storedToken) {
  store.dispatch(setCredentials({ user: storedLoggedUserEmail, accessToken: storedToken, refreshToken : storedRefreshToken }));
}
ReactDOM.createRoot(document.getElementById('root')!).render(
  <MantineProvider defaultColorScheme="light" theme={PinionTheme}>
    <ModalsProvider>
      <Notifications position="top-right"/>
        <Provider store={store}>
            <BrowserRouter>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </BrowserRouter>
        </Provider>
    </ModalsProvider>
  </MantineProvider>
)
